/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Invalid_DateInputs */

const vi_validation_invalid_date = /** @type {(inputs: Validation_Invalid_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày không hợp lệ (YYYY-MM-DD)`)
};

/**

* @param {Validation_Invalid_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_invalid_date = /** @type {((inputs?: Validation_Invalid_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Invalid_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_invalid_date(inputs)
});